import { render } from "./HeaderAdmin.vue?vue&type=template&id=c63d919c&scoped=true"
import script from "./HeaderAdmin.vue?vue&type=script&lang=js"
export * from "./HeaderAdmin.vue?vue&type=script&lang=js"

import "./HeaderAdmin.vue?vue&type=style&index=0&id=c63d919c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c63d919c"]])

export default __exports__